// extracted by mini-css-extract-plugin
export default {"cls1":"p2vdwpk0Fu8Tr6Gj2vSu","cls2":"KV6YdcBPP7cQAUrCX6ul p2vdwpk0Fu8Tr6Gj2vSu","isPhone":"nHWfA5jY13N6I5epEU4s"};